import styles from './labels.scss';

export const NewLabel = ({ className }) => (
  <span className={classnames(styles.new, className)}>NEW</span>
);